import React from 'react';

import styles from './styles.scss';
import JobDetailPerks from '../JobDetailPerks';
import JobDetailBenefits from '../JobDetailBenefits';

const JobDetailPerksBenefits = props => {
  const { className, jobBenefits } = props;

  return (
    <article className={`${className} ${styles.jobPerksBenefits}`}>
      <JobDetailBenefits
        className={styles.jobPerksBenefits__benefits}
        title="<strong>The</strong> Benefits"
        data={jobBenefits.theBenefits}
      />
      <JobDetailPerks
        className={styles.jobPerksBenefits__perks}
        title="<strong>The</strong> Perks"
        data={jobBenefits.thePerks}
      />
    </article>
  );
};

export default JobDetailPerksBenefits;
